export const fontList = [
        {family: "Avenir", property: "Avenir"},
        {family: "Helvetica Neue", property: "Helvetica Neue"},
        {family: "Montserrat", property: "Montserrat"},
        {family: "Open sans", property: "Open Sans"},
        {family: "Roboto", property: "Roboto"}
    ]